import React from 'react';
import { ArrowUpRight, ShoppingBag, Shield, BarChart3, Star } from 'lucide-react';
import { motion } from 'framer-motion';

const benefits = [
  { icon: Star, text: 'A+ Content & Enhanced Brand Pages' },
  { icon: Shield, text: 'Automated IP Protection & Violation Alerts' },
  { icon: BarChart3, text: 'Brand Analytics & Search Performance' },
  { icon: ShoppingBag, text: 'Sponsored Brands & Buy Box Advantage' },
];

const AmazonRegistrySection = ({ onOpenContactForm }) => (
  <section data-testid="amazon-registry-section" className="py-24 md:py-32 bg-stone-50 overflow-hidden">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <div className="grid lg:grid-cols-2 gap-16 items-center">
        <motion.div initial={{ opacity: 0, x: -80 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true, margin: "-100px" }} transition={{ duration: 0.7, ease: [0.25, 0.46, 0.45, 0.94] }}>
          <div className="bg-white border-2 border-stone-200 p-10 shadow-[8px_8px_0px_#d6d3d1]">
            <ShoppingBag className="w-14 h-14 text-emerald-900 mb-8" strokeWidth={1} />
            <h3 className="font-serif text-3xl font-bold text-stone-900 mb-3">Amazon Brand Registry</h3>
            <p className="text-stone-500 leading-relaxed mb-6">A registered trademark unlocks Amazon's best seller tools. Without it, you're competing with one arm tied behind your back.</p>
            <div className="flex items-center gap-2 text-sm text-emerald-900 font-bold"><div className="w-2 h-2 bg-orange-600" />Required: Active US Trademark</div>
          </div>
          <div className="mt-5 overflow-hidden border-2 border-stone-200 shadow-[6px_6px_0px_#d6d3d1]">
            <img src="https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=600&h=250&fit=crop" alt="E-commerce shipping" className="w-full h-40 object-cover" />
          </div>
        </motion.div>

        <motion.div initial={{ opacity: 0, x: 80 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true, margin: "-100px" }} transition={{ duration: 0.7, ease: [0.25, 0.46, 0.45, 0.94], delay: 0.15 }}>
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-orange-600 block mb-4">For Amazon Sellers</span>
          <h2 className="font-serif text-4xl sm:text-5xl tracking-tight text-stone-900 leading-tight mb-6">Stop Leaving<br/><span className="italic text-emerald-900">Revenue on the Table</span></h2>
          <p className="text-stone-500 leading-relaxed mb-8">Brand Registry gives you tools that directly increase sales. But it requires a federal trademark. We handle both.</p>
          <div className="space-y-3 mb-10">
            {benefits.map((b, i) => (
              <motion.div key={b.text} initial={{ opacity: 0, x: 30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.4, delay: 0.3 + i * 0.08 }}
                className="group flex items-center gap-4 p-4 bg-white border-2 border-stone-200 cursor-default transition-all duration-200 hover:border-stone-900 hover:-translate-y-1 hover:shadow-[4px_4px_0px_#1C1917]">
                <div className="w-10 h-10 bg-stone-100 border-2 border-stone-200 flex items-center justify-center flex-shrink-0 group-hover:bg-emerald-900 group-hover:border-emerald-900 transition-all duration-200">
                  <b.icon className="w-5 h-5 text-emerald-900 group-hover:text-white transition-colors duration-200" strokeWidth={1.5} />
                </div>
                <span className="text-sm font-semibold text-stone-700">{b.text}</span>
              </motion.div>
            ))}
          </div>
          <button data-testid="amazon-registry-cta" onClick={onOpenContactForm} className="group inline-flex items-center gap-2 px-8 py-4 bg-emerald-900 text-white font-bold text-sm tracking-wide border-2 border-emerald-900 hover:-translate-y-0.5 hover:shadow-[-6px_6px_0px_#EA580C] transition-all duration-200">
            Enroll in Brand Registry <ArrowUpRight className="w-4 h-4 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-transform duration-200" />
          </button>
        </motion.div>
      </div>
    </div>
  </section>
);
export default AmazonRegistrySection;
